import { CheckCircle, ArrowRight, Clock } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

const WHAT_HAPPENS = [
  'The programme team reads your profile in full.',
  'We verify your details and approve your account.',
  'Once approved, log in with the password you chose — we will email you.',
];

export default function CompleteStep({ applicationId, name, reviewStatus = 'pending_review' }) {
  const navigate = useNavigate();
  const firstName = (name || '').trim().split(' ')[0];
  const isAccepted = reviewStatus === 'accepted';

  return (
    <div className="ob-done">
      <div className="ob-done-badge">
        {isAccepted ? (
          <CheckCircle size={40} weight="fill" />
        ) : (
          <Clock size={40} weight="fill" />
        )}
      </div>

      <h1>{firstName ? `Nicely done, ${firstName}` : 'Nicely done'}</h1>

      <p>
        {isAccepted
          ? 'Your Talent Profile is approved. You can now log in with the password you set during onboarding.'
          : 'Your Talent Profile is with the programme team for review. You will be able to log in once they approve your account.'}
      </p>

      <div className="ob-done-card">
        <div className="ob-group-label">What happens next</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {WHAT_HAPPENS.map((line, index) => (
            <div key={line} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <span className="ob-rank-num" style={{ width: 24, height: 24, fontSize: 12 }}>
                {index + 1}
              </span>
              <span style={{ fontSize: 14, lineHeight: 1.6, color: '#475569', paddingTop: 2 }}>
                {line}
              </span>
            </div>
          ))}
        </div>

        {applicationId && (
          <div style={{ marginTop: 18, paddingTop: 16, borderTop: '1px solid #f1f5f9' }}>
            <div className="ob-kv-key">Your reference</div>
            <div className="ob-kv-val" style={{ fontVariantNumeric: 'tabular-nums' }}>
              #{String(applicationId).padStart(6, '0')}
            </div>
          </div>
        )}
      </div>

      <button
        type="button"
        className="ob-btn ob-btn-primary"
        style={{ width: '100%', maxWidth: 320 }}
        onClick={() => navigate(isAccepted ? '/dashboard' : '/login')}
      >
        {isAccepted ? 'Go to dashboard' : 'Back to login'}
        <ArrowRight size={16} weight="bold" />
      </button>
    </div>
  );
}
